import {
  LoginOutlined, LogoutOutlined, UserOutlined, AuditOutlined,
  CalendarOutlined, HistoryOutlined, TeamOutlined, ReadOutlined, HourglassOutlined,
  ContactsOutlined, ContainerOutlined, DatabaseOutlined, NotificationOutlined, ScheduleOutlined
} from '@ant-design/icons';
import React from 'react';
import { ROLES } from "./permissions";

export const routes = {
  profile: {
    key: "profile",
    slug: "profile",
    to: "/profile",
    title: "Perfil",
    icon: <UserOutlined />,
    showInMenu: false,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role, ROLES.user.role, ROLES.employee.role, ROLES.secretary.role],
  },

  login: {
    key: "login",
    slug: "login",
    to: "/login",
    title: "LOGIN",
    icon: <LoginOutlined />,
    showInMenu: false,
    showHeader: false,
    showSearch: false,
    action: null,
    role: [ROLES.admin.role, ROLES.user.role, ROLES.employee.role, ROLES.secretary.role],
  },

  medicalAppointments: {
    key: "medicalAppointments",
    slug: "medicalAppointments",
    to: "/medicalAppointments",
    title: "Solicitar Citas",
    icon: <CalendarOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role, ROLES.user.role, ROLES.secretary.role],
  },

  eventss: {
    key: "eventss",
    slug: "eventss",
    to: "/eventss",
    title: "Eventos",
    icon: <ScheduleOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role, ROLES.secretary.role],
  },

  medicalConsultations: {
    key: "medicalConsultations",
    slug: "medicalConsultations",
    to: "/medicalConsultations",
    title: "Consultas Médicas",
    icon: <AuditOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role, ROLES.secretary.role],
  },

  room: {
    key: "room",
    slug: "room",
    to: "/room",
    title: "Boxes",
    icon: <DatabaseOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role, ROLES.secretary.role],
  },

  boxesManager: {
    key: "boxesManager",
    slug: "boxesManager",
    to: "/boxesManager",
    title: "Gestion Boxes",
    icon: <CalendarOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role, ROLES.secretary.role, ROLES.employee.role],
  },

  MyConsults: {
    key: "MyConsults",
    slug: "MyConsults",
    to: "/MyConsults",
    title: "Mis Consultas",
    icon: <ReadOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role, ROLES.employee.role, ROLES.user.role],
  },

  timeToConsultations: {
    key: "timeToConsultations",
    slug: "timeToConsultations",
    to: "/timeToConsultations",
    title: "Tiempo Espera",
    icon: <HourglassOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role, ROLES.user.role],
  },

  typeMedicalConsultations: {
    key: "typeMedicalConsultations",
    slug: "typeMedicalConsultations",
    to: "/typeMedicalConsultations",
    title: "Tipo Consultas",
    icon: <ContainerOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role, ROLES.employee.role, ROLES.secretary.role,],
  },

  consultsNotifications: {
    key: "consultsNotifications",
    slug: "consultsNotifications",
    to: "/consultsNotifications",
    title: "Notificaciones",
    icon: <NotificationOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role, ROLES.secretary.role, ROLES.employee.role],
  },

  MedicalHistorys: {
    key: "MedicalHistorys",
    slug: "MedicalHistorys",
    to: "/MedicalHistorys",
    title: "Historiales Médicos",
    icon: <HistoryOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role],
  },

  employees: {
    key: "employees",
    slug: "employees",
    to: "/employees",
    title: "Trabajadores",
    icon: <TeamOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role],
  },

  clients: {
    key: "clients",
    slug: "clients",
    to: "/clients",
    title: "Clientes",
    icon: <ContactsOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role, ROLES.secretary.role],
  },

  users: {
    key: "users",
    slug: "users",
    to: "/users",
    title: "Usuarios",
    icon: <UserOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role],
  },
  logout: {
    key: "logout",
    slug: "logout",
    to: "/logout",
    title: "Cerrar Sesión",
    icon: <LogoutOutlined />,
    showInMenu: false,
    showHeader: false,
    showSearch: false,
    action: null,
    role: [ROLES.admin.role, ROLES.user.role, ROLES.employee.role, ROLES.secretary.role],
  },
};
